import { clsx } from 'clsx'

/** A small set of mutually exclusive choices shown as joined buttons, e.g. "This client only" / "All clients". */
export function Segmented<T extends string>({ value, onChange, options, label }: { value: T; onChange: (v: T) => void; options: ReadonlyArray<{ value: T; label: string }>; label: string }) {
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => onChange(o.value)}
          className={clsx('min-h-8 border px-3 text-small transition-colors', value === o.value ? 'border-ink bg-ink text-paper' : 'border-gray-300 text-charcoal hover:border-ink')}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
